import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit } from '@angular/core';
import { IconSize } from './icon-size.map';
import { Icon, ICONS_MAP_icon } from './icons.map';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sky-svg-icon[icon]',
  template: ``,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class SvgIconComponent implements OnInit {
  @Input() public icon!: Icon;
  @Input() public size: IconSize = 'w-4';

  public svgCode!: string;
  public sizeClass!: string;

  constructor(private readonly _host: ElementRef) {}

  public ngOnInit(): void {
    const host = this._host.nativeElement as HTMLElement;
    host.classList.add(this.size);
    host.innerHTML = ICONS_MAP_icon.get(this.icon) as string;
    host.firstElementChild?.classList.add('w-full', 'h-auto');
  }
}
